<template>
  <div>
    <div class="gallery-slider">
      <swiper ref="gallery-slider" :options="swiperOptions" class="h-100">
        <swiper-slide v-for="(slide, index) in slides" :key="index">
          <bg-image :src="slide.high" :placeholder="slide.low" :lazy-load="false" class="h-100">
            <div class="caption">{{slide.title}}</div>
          </bg-image>
        </swiper-slide>
      </swiper>

      <div class="nav-buttons">
        <button type="button" class="btn-prev" @click="slidePrev()">
          <i class="icon-arrow-medium-left"></i>
        </button>

        <button type="button" class="btn-next" @click="slideNext()">
          <i class="icon-arrow-medium-right"></i>
        </button>
      </div>
    </div>

    <div class="gallery-slider-thumbs">
      <swiper ref="gallery-slider-thumbs" :options="swiperOptionsThumbs">
        <swiper-slide v-for="(slide, index) in slides" :key="index">
          <!-- @click="goToSlide(index)" -->
          <button type="button">
            <bg-image :src="slide.thumb" :placeholder="slide.low" :lazy-load="false"></bg-image>
          </button>
        </swiper-slide>
      </swiper>

      <div class="nav-buttons">
        <button type="button" class="btn-prev" @click="thumbPrev()">
          <i class="icon-arrow-medium-left"></i>
        </button>

        <button type="button" class="btn-next" @click="thumbNext()">
          <i class="icon-arrow-medium-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    Swiper,
    SwiperSlide
  } from 'vue-awesome-swiper'

  export default {
    components: {
      Swiper,
      SwiperSlide
    },
    props: {
      slides: {
        type: Array,
        required: true,
        default: null
      }
    },
    data() {
      return {
        swiperOptions: {
          speed: 500,
        },
        swiperOptionsThumbs: {
          notNextTick: true,
          spaceBetween: 6,
          centeredSlides: true,
          slidesPerView: 'auto',
          touchRatio: 0.2,
          slideToClickedSlide: true,
        }
      }
    },
    methods: {
      slidePrev() {
        this.$refs['gallery-slider'].$swiper.slidePrev()
      },
      slideNext() {
        this.$refs['gallery-slider'].$swiper.slideNext()
      },
      thumbPrev() {
        this.$refs['gallery-slider-thumbs'].$swiper.slidePrev()
      },
      thumbNext() {
        this.$refs['gallery-slider-thumbs'].$swiper.slideNext()
      },
      // goToSlide(index) {
      //   this.$refs['gallery-slider'].$swiper.slideTo(index)
      // }
    },
    mounted() {
      this.$nextTick(() => {
        const swiperTop = this.$refs['gallery-slider'].$swiper
        const swiperThumbs = this.$refs['gallery-slider-thumbs'].$swiper

        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      })

      // this.$refs['gallery-slider-thumbs'].$swiper.slideTo(this.$refs['gallery-slider-thumbs'].$swiper.slides.length/2, 0, false)
    }
  }
</script>

<style lang="scss">
  @import 'src/sass/variables';
  @import 'node_modules/bootstrap/scss/vendor/rfs';

  .gallery-slider,
  .gallery-slider-thumbs {
    position: relative;

    .nav-buttons {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      right: 0;
      z-index: 5;

      .btn-prev,
      .btn-next {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        display: block;
        background: $white;
        opacity: 1;
        transition: opacity 250ms ease-in-out;
        width: 54px;
        height: 54px;
        border-radius: 15px;

        i {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: $secondary;

          &::before {
            @include font-size(1.5rem);
          }
        }

        &:hover {
          opacity: 0.8;
        }

        &:disabled {
          opacity: 0.5;
        }
      }

      .btn-prev {
        left: 0;
      }

      .btn-next {
        right: 0;
      }
    }
  }

  .gallery-slider {
    height: 90vh;
    margin-bottom: 6px;
    min-height: 400px;

    .caption {
      position: absolute;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba($white , 0.9);
      padding: 10px 20px;
      border-radius: 30px;
      font-weight: $font-weight-bold;
      letter-spacing: 0.05rem;
      @include font-size(1rem);
    }
  }

  .gallery-slider-thumbs {
    padding-left: 70px;
    padding-right: 70px;

    .swiper-wrapper {
      // display: flex;
      // justify-content: center;

      .swiper-slide {
        width: 200px;
        opacity: 0.5;
        transition: opacity 250ms ease-in-out;

        button {
          padding-top: 73%;
          width: 100%;
          position: relative;

          .bg-image-component {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
        }

        &.swiper-slide-active {
          opacity: 1;
        }
      }
    }

    .nav-buttons {

      .btn-prev,
      .btn-next {
        background: transparent;
      }
    }
  }
</style>